import { TableHeaderCheckbox } from 'primeng/table';
import { Component, OnInit, OnChanges, SimpleChanges, ChangeDetectionStrategy, DoCheck } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  // tslint:disable-next-line
  selector: 'miq-tableHeaderCheckbox',
  template: `
    <label class="container">
      <input
        #cb
        type="checkbox"
        [checked]="isAllSelected"
        [disabled]="disabled"
        (focus)="onFocus()"
        (blur)="onBlur()"
      />
      <span class="checkmark" (click)="onClick($event)"></span>
    </label>
  `,
  standalone: true,
})
export class MiqTableHeaderCheckboxComponent extends TableHeaderCheckbox implements OnInit, OnChanges, DoCheck {
  isAllSelected: boolean = false;
  private isProcessing: boolean = false;

  ngOnInit() {
    this.updateCheckboxState();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Update checkbox state when selection changes from parent
    if (changes['selection']) {
      this.updateCheckboxState();
    }
  }

  ngDoCheck(): void {
    // Keep header checkbox synced even when selection array mutates in-place.
    if (!this.isProcessing) {
      this.updateCheckboxState();
    }
  }

  private updateCheckboxState(): void {
    // Check if all rows are selected
    this.isAllSelected = this.updateCheckedState();
  }

  onClick(event: any) {
    // Stop event from bubbling to prevent double-firing
    event.stopPropagation();

    // Check if disabled is a function/signal that needs to be called
    const isDisabled = typeof this.disabled === 'function' ? this.disabled() : this.disabled;

    // Prevent execution if processing or disabled
    if (this.isProcessing || isDisabled) {
      return;
    }

    if (this.dataTable.value && this.dataTable.value.length > 0) {
      this.isProcessing = true;

      // Toggle selection directly using dataTable's method
      const newCheckedState = !this.isAllSelected;

      // Create a proper event structure for PrimeNG
      const checkboxEvent = {
        originalEvent: event,
        checked: newCheckedState,
      };

      this.dataTable.toggleRowsWithCheckbox(checkboxEvent, newCheckedState);

      // Update our local state to match the new selection
      this.isAllSelected = newCheckedState;
      this.isProcessing = false;
    }
  }

  onFocus() {
    // intentional to override parent behavior
  }

  onBlur() {
    // intentional to override parent behavior
  }
}
